import { IAppState } from '../../redux';
import { EMoneySource } from '../../redux/reducers';

export const selectIsMasterMoneySource = (state: IAppState): boolean => {
  const {
    user: { isSubAgent, moneySource },
  } = state;

  return isSubAgent && moneySource === EMoneySource.Master;
};
